import {Campaign} from "../../common/models/Campaign";
import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";

export const getCampaign = (id: number): Promise<Campaign> => {
    return AxiosClientFactory
        .getInstance()
        .get<Campaign>(`/api/campaigns/${id}`)
        .then((result) => result.data);
};